import { render } from "./ContactsBlock.vue?vue&type=template&id=2f375b86&scoped=true"
import script from "./ContactsBlock.vue?vue&type=script&lang=js"
export * from "./ContactsBlock.vue?vue&type=script&lang=js"

import "./ContactsBlock.vue?vue&type=style&index=0&id=2f375b86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\admin\\Desktop\\Расчосков\\rascheskov_katarakta_lending\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f375b86"]])

export default __exports__